import {Component, Input, OnInit} from '@angular/core';
import {FullTextSearchConfigurationModel} from "../../../../../../core/models/full-text-search/full-text-search-configuration.model";
import {FullTextSearchResultModel} from "../../../../../../core/models/full-text-search/full-text-search-result.model";

@Component({
  selector: 'sb-search-default',
  templateUrl: './search-default.component.html',
  styleUrls: ['./search-default.component.scss']
})
export class SearchDefaultComponent implements OnInit {

  @Input()
  configuration: FullTextSearchConfigurationModel;

  @Input()
  data: FullTextSearchResultModel;

  label: string;

  description: string;

  constructor() { }

  ngOnInit(): void {
    this.label = JSON.stringify(this.data, null, 2);

    this.label = this.data.Name || this.data.Number;
    this.description = this.data.Description || "";
  }

}
